module.exports = __webpack_public_path__ + "img/49.61b392e0.jpg";